export const CRITICAL_EVENTS_LABELS = [
  'Vols avec violence',
  'Incendie',
  'Squat de logement vacant',
  "Présence d'armes",
  'Rixes',
  'Menaces de mort',
  'Injures racistes ou discriminantes',
  'Agressions sexuelles',
  'Avec arme',
  'Avec arme par destination',
  'Sans arme',
]
